import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";
import { UncontrolledTooltip } from "reactstrap";

interface IProps {
    cacheTime: string;
    getSelectData: (reset_cache: boolean) => void;
}

export default function CacheTimeAndRefreshButton({
    cacheTime,
    getSelectData,
}: IProps) {
    if (!cacheTime) {
        return null;
    }

    return (
        <>
            <br />
            <span>
                Viewing cached data from{" "}
                {/* Format the date as x days, hours and minutes ago */}
                {format(new Date(cacheTime), "MMM d, H:mm")}
            </span>{" "}
            <FontAwesomeIcon
                id="refreshIcon"
                icon={faArrowsRotate}
                onClick={() => getSelectData(true)}
                style={{ cursor: "pointer" }}
            />
            <UncontrolledTooltip target="refreshIcon">
                Refresh cached data
            </UncontrolledTooltip>
        </>
    );
}
